import styled from 'styled-components';
import { fpx } from '../../../../styles/fluid';
import { MOBILE_GAMES_COUNT } from '../../helpers';

export const ScGamesGrid = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${fpx(16)};
  width: 100%;
  padding: 0 ${fpx(48)};

  @media (orientation: portrait) {
    width: ${fpx(344)};
    margin-top: ${fpx(32)};
    padding: 0;
  }
`;

export const ScGamesHeading = styled.h2`
  margin: 0;
  color: #fff;
  font-size: ${fpx(22)};
  font-weight: 700;
  line-height: ${fpx(28)};
  letter-spacing: 0.44px;
  text-transform: uppercase;

  @media (orientation: portrait) {
    font-size: ${fpx(18)};
    line-height: ${fpx(26)};
    letter-spacing: 0.4px;
  }
`;

export const ScGamesList = styled.div`
  display: grid;
  grid-template-columns: repeat(8, ${fpx(134)});
  gap: ${fpx(16)};

  @media (orientation: portrait) {
    grid-template-columns: repeat(3, ${fpx(110)});
    gap: ${fpx(7)};

    & > :nth-child(n + ${MOBILE_GAMES_COUNT + 1}) {
      display: none;
    }
  }
`;

export const ScGameCard = styled.button`
  display: block;
  width: ${fpx(134)};
  height: ${fpx(134)};
  padding: 0;
  border: 0;
  background: none;
  border-radius: ${fpx(16)};
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (hover: hover) {
    &:hover {
      transform: scale(1.04);
    }
  }

  @media (orientation: portrait) {
    width: ${fpx(110)};
    height: ${fpx(110)};
    border-radius: ${fpx(8)};
  }
`;
